module.exports = __webpack_public_path__ + "icon-star-on.svg?83c5c73d3fa3f554ed9c3ce731839c9c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-star-on.svg
// module id = 37
// module chunks = 0